import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import CheckIcon from '../../../../../commonComponents/icons/CheckIcon';
import LockIcon from '../../../../../commonComponents/icons/LockIcon';
import { formatVA } from '../../../../../services/utilityFunctions';

function TrophiesSection({ t, data }) {
  if (!data || data.length === 0) return null;

  const nextToEarnIndex = data.findIndex(trophy => !trophy.earned);
  const nextToEarn = nextToEarnIndex >= 0 ? data[nextToEarnIndex] : null;

  const getState = (trophy, index) => {
    if (trophy.earned) return 'earned';
    if (index === nextToEarnIndex) return 'next';
    return 'locked';
  };

  return (
    <div className="pureliink-trophies-section">
      <h4 className="career-section-title">
        {t('pureliink.career.progression.trophies')}
      </h4>

      <div className="pureliink-trophy-card">
        <div className="pureliink-trophy-card__header">
          <span>{t('pureliink.career.trophies.basedOnPersonalVA')}</span>
          {nextToEarn?.va != null && (
            <span>
              {t('pureliink.career.trophies.current')}{' '}
              <strong>{formatVA(nextToEarn.va)} VA</strong>
            </span>
          )}
        </div>

        <div className="pureliink-trophy-rows">
          {data.map((trophy, index) => {
            const state = getState(trophy, index);
            const missingVA =
              state === 'next' && trophy.minimumPersonalVA != null && trophy.va != null
                ? trophy.minimumPersonalVA - trophy.va
                : null;

            return (
              <div
                key={trophy.identifier}
                className={`trophy-row trophy-row--${state}`}
              >
                <div className={`trophy-row__icon-container trophy-row__icon-container--${state}`}>
                  {trophy.icon?.thumb ? (
                    <img
                      src={trophy.icon.thumb}
                      alt={trophy.name}
                      className="trophy-row__icon"
                    />
                  ) : (
                    <span className="trophy-row__icon-fallback">🏆</span>
                  )}
                </div>

                <div className="trophy-row__name">
                  <span className={state === 'locked' ? 'trophy-row__name--muted' : ''}>
                    {trophy.name}
                  </span>
                </div>

                {state === 'next' && missingVA != null && missingVA > 0 && (
                  <span className="trophy-row__missing">
                    {t('pureliink.career.trophies.missing', formatVA(missingVA))}
                  </span>
                )}

                <div className={`trophy-row__va ${state === 'locked' ? 'trophy-row__va--muted' : ''}`}>
                  {trophy.minimumPersonalVA != null
                    ? `${formatVA(trophy.minimumPersonalVA)} VA`
                    : ''}
                </div>

                <div className="trophy-row__status">
                  {state === 'earned' ? (
                    <span className="trophy-row__status-circle trophy-row__status-circle--earned">
                      <CheckIcon width={12} height={9} color="#ffffff" />
                    </span>
                  ) : (
                    <span className={`trophy-row__status-circle trophy-row__status-circle--${state}`}>
                      <LockIcon
                        width={10}
                        height={13}
                        color={state === 'next' ? '#92400e' : '#9ca3af'}
                      />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

TrophiesSection.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      identifier: PropTypes.string,
      minimumPersonalVA: PropTypes.number,
      name: PropTypes.string,
      va: PropTypes.number,
      icon: PropTypes.shape({
        thumb: PropTypes.string,
        medium: PropTypes.string,
        url: PropTypes.string,
      }),
      earned: PropTypes.bool,
    }),
  ).isRequired,
};

export default translate(TrophiesSection);
